// extracted by mini-css-extract-plugin
module.exports = {"container":"SavedFilters_container__s6axN"};